module.exports = __webpack_public_path__ + "img/cnc-02-bg-intro.6735d15e.jpg";